const COOKIE_NAME = 'postRates';

export default class Rating {
    constructor(context) {
        this.postId = context.getAttribute('data-id');

        // проверяем, оценивал ли уже пользователь эту статью
        this.ratings = {};
        this.getRatingsFromCookie();
        this.toggleRatingText({
            postId: this.postId,
            isVisible: Boolean(this.ratings[this.postId])
        });

        this.bindEvents(this.postId);
        // при добавлении в документ новых блоков "Оценить статью",
        // навешиваем новые обработчики
        document.addEventListener('updateRating', e => {
            const postId = e.detail;
            this.bindEvents(e.detail);
            this.toggleRatingText({
                postId,
                isVisible: Boolean(this.ratings[postId])
            });
        });
    }

    bindEvents(postId) {
        const $buttons = document.querySelectorAll(
            `#rating-${postId} [data-rate]`
        );
        $buttons.forEach($btn => {
            const rate = $btn.getAttribute('data-rate');
            const postId = $btn
                .closest('[data-post-id]')
                ?.getAttribute('data-post-id');
            $btn.addEventListener('click', () => {
                this.setRate({ rate, postId });
            });
        });

        const $cancelBtn = document.querySelector(
            `#rating-${postId} .rate__cancel`
        );
        $cancelBtn?.addEventListener('click', e => {
            e.preventDefault();
            if (window.confirm('Отменить отзыв?')) {
                this.setRate({ rate: '0', postId });
            }
        });
    }

    setRate({ rate, postId }) {
        window.togglePreloader();
        const url = Routing.generate('api.web.blog.rate', {
            post: postId,
            rate
        });
        MNTK.fetchJson(url, { method: 'POST' })
            .then(({ json }) => {
                const { status, rating } = json;
                this.ratings[postId] = rate;

                if (status === 1) {
                    const $cancelRate = document.querySelector(
                        `#rating-${postId} .rate__cancel`
                    );
                    $cancelRate?.classList.toggle('hidden', rate === '0');

                    this.updatePostStats(postId, rating);
                }

                if (rate === '-1') {
                    window.openModal('post-feedback-modal');
                }
            })
            .then(() => this.setCookieRate({ postId, rate }))
            .then(() => {
                this.toggleRatingText({
                    postId,
                    isVisible: rate !== '0'
                });
                window.togglePreloader();
            })
            .catch(error => {
                console.log(error);
                window.togglePreloader();
                window.openMessageModal(error.message, 'Произошла ошибка!');
            });
    }

    /** Обновляем статистику поста */
    updatePostStats(postId, rating) {
        const $postStats = document.querySelector(
            `#rating-${postId} [data-rating]`
        );
        if ($postStats) {
            $postStats.textContent = rating > 0 ? `+${rating}` : rating;
            $postStats.classList.toggle('text-color-green', rating > 0);
        }
    }

    /**
     * Получаем рейтинги из кук
     * @returns {string[]|Array}
     */
    getRatingsFromCookie() {
        const cookie = MNTK.cookieParse.getEscapedCookie(COOKIE_NAME);
        cookie?.split(',').forEach(c => {
            const [postId, rate] = c.split(':');
            this.ratings[postId] = rate;
        });
        MNTK.emit('updateExcludedPosts', Object.keys(this.ratings));
    }

    /** Устанавливаем id статьи в куку */
    setCookieRate({ postId, rate }) {
        const rates = [];
        Object.keys(this.ratings)
            .filter(key => key !== postId)
            .forEach(key => {
                rates.push(`${key}:${this.ratings[key]}`);
            });
        rate !== '0' && rates.push(`${postId}:${rate}`);
        MNTK.cookieParse.setEscapedCookie(COOKIE_NAME, rates, 365);
    }

    toggleRatingText({ postId, isVisible }) {
        const $card = document.getElementById(`rating-${postId}`);
        const $rating = $card.querySelector('.rate');
        const $controls = $rating.querySelector('.rate__buttons');
        const $buttons = $controls.querySelectorAll('button');
        const $text = $controls.querySelector('span');
        const $title = $rating.querySelector('h3');

        $rating.classList.toggle('flex-wrap', isVisible);
        $controls.classList.toggle('ml-0', isVisible);
        $buttons.forEach($btn => $btn.classList.toggle('hidden', isVisible));
        $text.textContent = isVisible
            ? this.ratings[postId] === '1'
                ? 'Вам понравилась эта статья'
                : 'Вам не понравилась эта статья'
            : '';
        $text.classList.toggle('hidden', !isVisible);
        $title.classList.toggle('hidden', isVisible);
    }
}
